import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { BiomarkerRow } from './BiomarkerRow';
import { GradeBadge } from './GradeBadge';
import type { Grade } from '../utils/grade';
import { getStatus } from '../utils/biomarkers';
import type { Biomarker } from '../types/platform';
type BiomarkerGroupProps = {
  category: string;
  items: Biomarker[];
  totalInCategory: number;
  grade: Grade;
};
export function BiomarkerGroup({
  category,
  items,
  totalInCategory,
  grade
}: BiomarkerGroupProps) {
  const [open, setOpen] = useState(true);
  const flagged = items.filter(b => getStatus(b) !== 'optimal').length;
  const id = `group-${category.replace(/\W+/g, '-').toLowerCase()}`;
  return <section className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02]" data-id="element-43" data-mp="1nvzo1osxrgzv">
      <button onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls={id} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left hover:bg-white/[0.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#9b8cf0]" data-id="element-44" data-mp="3e4rl62hgbrhd">
        <span className="flex items-center gap-3" data-id="element-45" data-mp="19y7xuahvj9wp">
          <GradeBadge grade={grade} data-id="element-46" data-mp="19wwyqnzdiqbx" />
          <h2 className="font-medium" data-id="element-47" data-mp="14yv9tmf9nwsj">{category}</h2>
          <span className="font-mono text-xs text-muted-foreground" data-id="element-48" data-mp="14zdhdf7dpxfr">
            {items.length}
            {items.length !== totalInCategory && ` of ${totalInCategory}`}
          </span>
        </span>
        <span className="flex items-center gap-3" data-id="element-49" data-mp="cbr1b7gyt0c0">
          {flagged > 0 ? <span className="rounded-full border border-[#f5b454]/30 px-2 py-0.5 text-[11px] text-[#f5b454]" data-id="element-50" data-mp="r7ylw8wac3rt">
              {flagged} to review
            </span> : <span className="text-[11px] text-[#8fd3b0]" data-id="element-51" data-mp="22lklknzrtnrl">All in range</span>}
          <ChevronDown className={`size-4 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-52" data-mp="1xnskp4h5erb9" />
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-53" data-mp="24q7gv90lom60">
        {open && <motion.ul id={id} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} className="divide-y divide-white/5 border-t border-white/10" data-id="element-54" data-mp="29or37aj3vzyw">
            {items.map(b => <BiomarkerRow key={b.id} biomarker={b} data-id="element-55" data-mp="1qz2dpwy0xbqx" />)}
          </motion.ul>}
      </AnimatePresence>
    </section>;
}